import { BankStatement, COMPANY_TYPES, ItemInfoType } from "interfaces";
import { CopyableText } from "ui";
import { formatWithDecimals } from "utils";

export const STATEMENT_LABELS: Record<
  keyof Omit<
    BankStatement,
    "role" | "status" | "fiatAmount" | "fiatCurrency" | "isResident" | "type" | "paymentType" | "rubAmount"
  >,
  string
> & {
  amount: string;
} = {
  companyName: "Организация",
  companyRegistrationNumber: "ОГРН",
  inn: "ИНН",
  kpp: "КПП",
  paymentPurpose: "Назначение платежа",
  bankName: "Банк-получатель",
  bik: "БИК",
  correspondentAccount: "Кор. счет",
  accountNumber: "Расчетный счет",
  amount: "Сумма",
};

export const getCompanyInfo = (data: BankStatement): Array<ItemInfoType> => {
  const { companyRegistrationNumber, inn, kpp, companyName, type } = data;

  return [
    {
      label: STATEMENT_LABELS.companyName,
      text: <CopyableText>{companyName}</CopyableText>,
    },
    {
      label: type === COMPANY_TYPES.COMPANY ? "ОГРН" : "ОГРНИП",
      text: <CopyableText>{companyRegistrationNumber}</CopyableText>,
    },
    {
      label: STATEMENT_LABELS.inn,
      text: <CopyableText>{inn}</CopyableText>,
    },
    type === COMPANY_TYPES.COMPANY && {
      label: STATEMENT_LABELS.kpp,
      text: <CopyableText>{kpp}</CopyableText>,
    },
  ].filter((c) => !!c);
};

export const getBankInfo = (data: BankStatement): Array<ItemInfoType> => {
  const { bankName, bik, accountNumber, correspondentAccount } = data;

  return [
    {
      label: STATEMENT_LABELS.bankName,
      text: <CopyableText>{bankName}</CopyableText>,
    },
    {
      label: STATEMENT_LABELS.bik,
      text: <CopyableText>{bik}</CopyableText>,
    },
    {
      label: STATEMENT_LABELS.correspondentAccount,
      text: <CopyableText>{correspondentAccount}</CopyableText>,
    },
    {
      label: STATEMENT_LABELS.accountNumber,
      text: <CopyableText>{accountNumber}</CopyableText>,
    },
  ].filter((c) => !!c);
};

export const getPaymentAmountInfo = (data: BankStatement): Array<ItemInfoType> => {
  const { rubAmount } = data;

  return [
    {
      label: STATEMENT_LABELS.amount,
      text: <CopyableText>{`${formatWithDecimals(rubAmount)} RUB`}</CopyableText>,
    },
  ].filter((c) => !!c);
};
